import { FC } from 'react';
import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import CardShopPage from '../../../pages/Cards/CardShopPage';
import CardShopMobile from '../../../pages/Mobile/Cards/CardShopMobile';

const CardShopResponsive: FC = () => {
    const { isMobile } = useResponsiveRedux();
    return isMobile ? <CardShopMobile /> : <CardShopPage />;
};

export default CardShopResponsive;
